import './index.scss';

export default function Switch({ value, id, onChange, isDisabled = false }) {
  return (
    <label className="switch">
      <input
        type="checkbox"
        id={id}
        checked={value ? value : false}
        onChange={(e) => onChange(e.target.checked)}
        disabled={isDisabled}
      />
      <span className="slider round"></span>
    </label>
  );
}
